module.exports = __webpack_public_path__ + "img/background.d75bb409.jpg";